(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const giftWrapButtonSelector = '[data-add-gift-wrap-drawer]';
  const assignButtonSelector = '[data-assign-gift-wrap]';
  const unassignButtonSelector = '[data-unassign-gift-wrap]';
  const editMessageButtonSelector = '[data-edit-gift-wrap-message]';
  const saveMessageButtonSelector = '[data-save-gift-message]';
  const closeMessageButtonSelector = '[data-close-gift-message-modal]';
  const messageTextareaSelector = '[data-gift-message-textarea]';
  const messageModalSelector = '[data-gift-message-modal]';
  const giftWrapCardSelector = '[data-gift-wrap-cart-key]';
  const quantityPlusSelector = '.quantity-plus';
  const cartQuantityUpdateEventName = 'quantity-selector:update';
  function getConfiguredGiftWrapProductId() {
    return (
      document
        .querySelector('[data-cart-drawer-gift-wrap-product-id]')
        ?.getAttribute('data-cart-drawer-gift-wrap-product-id') || ''
    );
  }
  const loadingClass = 'is-loading';
  const giftWrapDrawerState = (window.__giftWrapDrawerState = window.__giftWrapDrawerState || {
    isNormalizingGiftWrapLines: false,
    normalizeTimer: null,
    messageContext: null,
    isFastAddingGiftWrap: false,
    isFastAddingRegularProduct: false,
    isAssigningGiftItem: false,
    interactionLockCount: 0,
  });
  const liveCartCache = {
    data: null,
    fetchedAt: 0,
    pending: null,
  };

  function getSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);
  }

  function setDrawerInteractionLock(locked) {
    if (locked) {
      giftWrapDrawerState.interactionLockCount += 1;
    } else {
      giftWrapDrawerState.interactionLockCount = Math.max(0, giftWrapDrawerState.interactionLockCount - 1);
    }

    const shouldLock = giftWrapDrawerState.interactionLockCount > 0;
    const cartItemsComponent = document.querySelector('cart-items-component');
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartItemsComponent instanceof HTMLElement) {
      cartItemsComponent.classList.toggle('cart-items-disabled', shouldLock);
    }
    if (cartDrawer instanceof HTMLElement) {
      cartDrawer.classList.toggle('cart-drawer--busy', shouldLock);
    }
  }

  function triggerCartUpdate(sections, resource = null) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          sourceId: 'cart-drawer-gift-wrap',
          resource: resource || undefined,
          data: {
            source: 'cart-drawer-gift-wrap',
            sections: sections || {},
          },
        },
      })
    );
  }

  function parseLineProperties(serializedProperties) {
    if (!serializedProperties) return {};
    try {
      const parsed = JSON.parse(serializedProperties);
      if (!parsed || typeof parsed !== 'object') return {};
      return parsed;
    } catch (error) {
      console.error('Failed to parse line properties', error);
      return {};
    }
  }

  function normalizeProperties(properties) {
    if (!properties || typeof properties !== 'object') return {};
    const normalized = {};
    for (const [key, value] of Object.entries(properties)) {
      if (!key) continue;
      if (value === null || value === undefined) continue;
      if (typeof value === 'object') continue;
      normalized[key] = String(value);
    }
    return normalized;
  }

  function generateWrapperInstanceId() {
    return `gw_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  }

  function sanitizeSplitLineProperties(properties) {
    const cleaned = normalizeProperties(properties || {});
    delete cleaned._gift_wrap_instance_id;
    delete cleaned['Gift Wrap Instance'];
    delete cleaned._gift_wrap_source;
    delete cleaned._added_with_product;
    delete cleaned._gift_wrap_message;
    delete cleaned['Gift Message'];
    clearAttachedProductProperties(cleaned);
    return cleaned;
  }

  function setLiveCartCache(cartData) {
    if (!Array.isArray(cartData?.items)) return;
    liveCartCache.data = cartData;
    liveCartCache.fetchedAt = Date.now();
  }

  function clearLiveCartCache() {
    liveCartCache.data = null;
    liveCartCache.fetchedAt = 0;
    liveCartCache.pending = null;
  }

  async function getLiveLineProperties({ key, line, cartData = null }) {
    try {
      const resolvedCartData = cartData || (await getLiveCartData());
      if (!Array.isArray(resolvedCartData?.items)) return null;

      let item = null;
      if (key) {
        item = resolvedCartData.items.find((cartItem) => cartItem.key === key) || null;
      }
      if (!item && line) {
        const index = Number(line) - 1;
        if (index >= 0 && index < resolvedCartData.items.length) {
          item = resolvedCartData.items[index];
        }
      }

      if (!item || typeof item.properties !== 'object' || item.properties == null) {
        return null;
      }
      return item.properties;
    } catch (error) {
      console.error('Failed to read live cart line properties', error);
      return null;
    }
  }

  async function getLiveLineItem({ key, line, cartData = null }) {
    try {
      const resolvedCartData = cartData || (await getLiveCartData());
      if (!Array.isArray(resolvedCartData?.items)) return null;

      let item = null;
      if (key) {
        item = resolvedCartData.items.find((cartItem) => cartItem.key === key) || null;
      }
      if (!item && line) {
        const index = Number(line) - 1;
        if (index >= 0 && index < resolvedCartData.items.length) {
          item = resolvedCartData.items[index];
        }
      }

      return item || null;
    } catch (error) {
      console.error('Failed to read live cart line item', error);
      return null;
    }
  }

  async function getLiveCartData({ force = false } = {}) {
    const now = Date.now();
    const isFresh = now - liveCartCache.fetchedAt < 400;
    if (!force && liveCartCache.data && isFresh) {
      return liveCartCache.data;
    }
    if (!force && liveCartCache.pending) {
      return liveCartCache.pending;
    }

    const fetchPromise = (async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const cartData = await response.json();
      if (!Array.isArray(cartData?.items)) return null;
      setLiveCartCache(cartData);
      return cartData;
    })();

    liveCartCache.pending = fetchPromise;
    try {
      return await fetchPromise;
    } catch (error) {
      console.error('Failed to read live cart data', error);
      return null;
    } finally {
      liveCartCache.pending = null;
    }
  }

  function getWrapperInstanceIdFromItem(cartItem) {
    if (!cartItem || typeof cartItem !== 'object') return '';
    const properties = cartItem.properties || {};
    return properties._gift_wrap_instance_id || properties['Gift Wrap Instance'] || '';
  }

  function getAssignmentPropertyLines(properties) {
    if (!properties || typeof properties !== 'object') return [];
    const excludedKeys = new Set([
      '_gift_wrap_instance_id',
      'Gift Wrap Instance',
      '_gift_wrap_source',
      '_added_with_product',
      '_gift_wrap_message',
      '_gift_wrap_split_instance_id',
      'gift_wrap_split_instance_id',
      'Gift Message',
      'Attached Products',
    ]);
    return Object.entries(properties)
      .filter(([key, value]) => {
        if (!key || excludedKeys.has(key)) return false;
        if (typeof value === 'object' || value === null || value === undefined || String(value).trim() === '') return false;
        if (/^Attached Product \d+$/.test(key)) return false;
        return true;
      })
      .map(([key, value]) => `${key}: ${String(value).trim()}`);
  }

  function buildAttachedProductsSummary(items, wrapperId, options = {}) {
    if (!wrapperId || !Array.isArray(items)) return '';
    const excludedKeys = options.excludedKeys instanceof Set ? options.excludedKeys : new Set();
    const attachedItems = items.filter((item) => {
      if (!item) return false;
      if (excludedKeys.has(item.key)) return false;
      if (Number(item.product_id || 0) === Number(getConfiguredGiftWrapProductId() || 0)) return false;
      return getWrapperInstanceIdFromItem(item) === wrapperId;
    });
    if (!attachedItems.length) return '';

    return attachedItems
      .map((item) => {
        const title = item.product_title || item.title || 'Product';
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
        const quantitySuffix = Number(item.quantity) > 1 ? ` x${item.quantity}` : '';
        const propertyLines = getAssignmentPropertyLines(item.properties || {});
        const propertiesSuffix = propertyLines.length ? ` - ${propertyLines.join(' | ')}` : '';
        return `${title}${variantTitle}${quantitySuffix}${propertiesSuffix}`;
      })
      .join('\n');
  }

  function clearAttachedProductProperties(properties) {
    if (!properties || typeof properties !== 'object') return;
    delete properties['Attached Products'];
    for (const key of Object.keys(properties)) {
      if (/^Attached Product \d+$/.test(key)) {
        delete properties[key];
      }
    }
  }

  function applyAttachedProductProperties(properties, attachedSummary) {
    clearAttachedProductProperties(properties);
    if (!attachedSummary) return;
    const lines = attachedSummary
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    if (!lines.length) return;
    lines.forEach((line, index) => {
      properties[`Attached Product ${index + 1}`] = line;
    });
  }

  async function syncGiftWrapDisplayProperties({
    wrapperId,
    giftWrapLineKey = '',
    giftMessage = null,
    cartData = null,
    includeSections = true,
  }) {
    if (!wrapperId) return;
    const resolvedCartData = cartData || (await getLiveCartData());
    if (!resolvedCartData) return;

    const items = resolvedCartData.items || [];
    let giftWrapLine = null;
    if (giftWrapLineKey) {
      giftWrapLine = items.find((item) => item.key === giftWrapLineKey) || null;
    }
    if (!giftWrapLine) {
      giftWrapLine =
        items.find(
          (item) =>
            item.product_id === getConfiguredGiftWrapProductId() && getWrapperInstanceIdFromItem(item) === wrapperId
        ) || null;
    }
    if (!giftWrapLine) return;

    const properties = normalizeProperties(giftWrapLine.properties || {});
    properties._gift_wrap_instance_id = getWrapperInstanceIdFromItem(giftWrapLine) || wrapperId;
    delete properties['Gift Wrap Instance'];

    const attachedSummary = buildAttachedProductsSummary(items, wrapperId, {
      excludedKeys: new Set([giftWrapLine.key]),
    });
    applyAttachedProductProperties(properties, attachedSummary);

    const normalizedMessage =
      giftMessage === null ? String(properties._gift_wrap_message || '').trim() : String(giftMessage).trim();
    if (normalizedMessage) {
      properties._gift_wrap_message = normalizedMessage;
      properties['Gift Message'] = normalizedMessage;
    } else {
      delete properties._gift_wrap_message;
      delete properties['Gift Message'];
    }

    await updateCartLine({
      key: giftWrapLine.key,
      quantity: giftWrapLine.quantity,
      properties,
      includeSections,
    });
  }

  async function syncAssignedProductsGiftMessage({
    wrapperId,
    giftMessage = '',
    cartData = null,
    includeSections = true,
  }) {
    if (!wrapperId) return;
    const resolvedCartData = cartData || (await getLiveCartData());
    if (!resolvedCartData || !Array.isArray(resolvedCartData.items)) return;

    const normalizedMessage = String(giftMessage).trim();
    const assignedItems = resolvedCartData.items.filter((item) => {
      if (!item) return false;
      if (Number(item.product_id || 0) === Number(getConfiguredGiftWrapProductId() || 0)) return false;
      return getWrapperInstanceIdFromItem(item) === wrapperId;
    });
    if (!assignedItems.length) return;

    for (let index = 0; index < assignedItems.length; index += 1) {
      const assignedItem = assignedItems[index];
      const properties = normalizeProperties(assignedItem.properties || {});
      properties._gift_wrap_instance_id = getWrapperInstanceIdFromItem(assignedItem) || wrapperId;
      delete properties['Gift Wrap Instance'];
      if (normalizedMessage) {
        properties['Gift Message'] = normalizedMessage;
      } else {
        delete properties['Gift Message'];
      }

      await updateCartLine({
        key: assignedItem.key,
        quantity: assignedItem.quantity,
        properties,
        includeSections: includeSections && index === assignedItems.length - 1,
      });
    }
  }

  async function removeOrphanedAssignedGiftMessages(cartData = null) {
    const resolvedCartData = Array.isArray(cartData?.items) ? cartData : await getLiveCartData({ force: true });
    if (!resolvedCartData || !Array.isArray(resolvedCartData.items)) return resolvedCartData;

    const wrapperIdsInCart = new Set(
      resolvedCartData.items
        .filter((item) => Number(item?.product_id || 0) === Number(getConfiguredGiftWrapProductId() || 0))
        .map((item) => getWrapperInstanceIdFromItem(item))
        .filter(Boolean)
    );

    const orphanAssignedItems = resolvedCartData.items.filter((item) => {
      if (!item) return false;
      if (Number(item.product_id || 0) === Number(getConfiguredGiftWrapProductId() || 0)) return false;
      const wrapperId = getWrapperInstanceIdFromItem(item);
      if (!wrapperId) return false;
      if (wrapperIdsInCart.has(wrapperId)) return false;
      const message = String(item.properties?.['Gift Message'] || '').trim();
      return message.length > 0;
    });

    if (!orphanAssignedItems.length) return resolvedCartData;

    for (let index = 0; index < orphanAssignedItems.length; index += 1) {
      const orphanItem = orphanAssignedItems[index];
      const properties = normalizeProperties(orphanItem.properties || {});
      delete properties['Gift Message'];
      await updateCartLine({
        key: orphanItem.key,
        quantity: orphanItem.quantity,
        properties,
        includeSections: index === orphanAssignedItems.length - 1,
      });
    }

    return getLiveCartData({ force: true });
  }

  async function syncAllGiftWrapDisplayPropertiesFromCart(cartData = null) {
    const resolvedCartData = Array.isArray(cartData?.items) ? cartData : await getLiveCartData({ force: true });
    if (!resolvedCartData || !Array.isArray(resolvedCartData.items)) return;
    if (!Number(getConfiguredGiftWrapProductId() || 0)) return;

    const giftWrapItems = resolvedCartData.items.filter(
      (item) => Number(item?.product_id || 0) === Number(getConfiguredGiftWrapProductId() || 0)
    );
    if (!giftWrapItems.length) return;

    for (let index = 0; index < giftWrapItems.length; index += 1) {
      const giftWrapItem = giftWrapItems[index];
      const wrapperId = getWrapperInstanceIdFromItem(giftWrapItem) || giftWrapItem.key || '';
      if (!wrapperId) continue;
      const includeSections = index === giftWrapItems.length - 1;
      await syncGiftWrapDisplayProperties({
        wrapperId,
        giftWrapLineKey: giftWrapItem.key || '',
        cartData: resolvedCartData,
        includeSections,
      });
    }
  }

  function getWrapperSummaryLinesFromDom(wrapperCard) {
    if (!(wrapperCard instanceof HTMLElement)) return [];
    const productItems = Array.from(
      wrapperCard.querySelectorAll('.cart-drawer-gift-assignment-card__section .cart-drawer-gift-assignment-list .cart-drawer-gift-assignment-item')
    );
    if (!productItems.length) return [];

    const section = wrapperCard.querySelector('.cart-drawer-gift-assignment-card__section');
    const assignedSection =
      Array.from(wrapperCard.querySelectorAll('.cart-drawer-gift-assignment-card__section')).find((node) =>
        node.querySelector('.cart-drawer-gift-assignment-card__label')?.textContent?.trim() === 'Gift Items:'
      ) || section;
    const assignedItems = assignedSection
      ? Array.from(assignedSection.querySelectorAll('.cart-drawer-gift-assignment-item'))
      : [];

    return assignedItems
      .map((item) => {
        const title = item.querySelector('.cart-drawer-gift-assignment-item__title')?.textContent?.trim() || '';
        const variant = item.querySelector('.cart-drawer-gift-assignment-item__variant')?.textContent?.trim() || '';
        const propertyLines = Array.from(item.querySelectorAll('.cart-drawer-gift-assignment-item__property'))
          .map((node) => node.textContent?.trim() || '')
          .filter(Boolean);
        if (!title) return '';
        const base = variant ? `${title} (${variant})` : title;
        return propertyLines.length ? `${base} - ${propertyLines.join(' | ')}` : base;
      })
      .filter(Boolean);
  }

  function getGiftMessageFromDom(wrapperCard) {
    if (!(wrapperCard instanceof HTMLElement)) return '';
    const summary = wrapperCard.querySelector('.cart-drawer-gift-assignment-card__message-summary');
    return summary?.textContent?.trim() || '';
  }

  async function syncGiftWrapDisplayPropertiesFromDom() {
    const cards = Array.from(document.querySelectorAll(giftWrapCardSelector));
    if (!cards.length) return;

    for (let index = 0; index < cards.length; index += 1) {
      const card = cards[index];
      const wrapperCard = card instanceof HTMLElement ? card : null;
      if (!wrapperCard) continue;
      const wrapperId = wrapperCard.getAttribute('data-wrapper-id') || '';
      const lineKey = wrapperCard.getAttribute('data-gift-wrap-cart-key') || '';
      const quantity = Number(wrapperCard.getAttribute('data-gift-wrap-line-quantity') || '0');
      if (!wrapperId || !lineKey || quantity <= 0) continue;

      const baseProperties = parseLineProperties(wrapperCard.getAttribute('data-gift-wrap-line-properties') || '');
      const properties = normalizeProperties(baseProperties);
      properties._gift_wrap_instance_id = properties._gift_wrap_instance_id || wrapperId;
      delete properties['Gift Wrap Instance'];

      const summaryLines = getWrapperSummaryLinesFromDom(wrapperCard);
      clearAttachedProductProperties(properties);
      summaryLines.forEach((line, index) => {
        properties[`Attached Product ${index + 1}`] = line;
      });

      const giftMessage = getGiftMessageFromDom(wrapperCard);
      if (giftMessage) {
        properties._gift_wrap_message = giftMessage;
        properties['Gift Message'] = giftMessage;
      } else {
        delete properties._gift_wrap_message;
        delete properties['Gift Message'];
      }

      const normalizedCurrent = normalizeProperties(baseProperties);
      delete normalizedCurrent['Gift Wrap Instance'];
      const nextSerialized = JSON.stringify(properties);
      const currentSerialized = JSON.stringify(normalizedCurrent);
      if (nextSerialized === currentSerialized) continue;

      await updateCartLine({
        key: lineKey,
        quantity,
        properties,
        includeSections: index === cards.length - 1,
      });
    }
  }

  function getGiftMessageModalElements() {
    const modal = document.querySelector(messageModalSelector);
    if (!(modal instanceof HTMLDialogElement)) return null;
    const textarea = modal.querySelector(messageTextareaSelector);
    const saveButton = modal.querySelector(saveMessageButtonSelector);
    if (!(textarea instanceof HTMLTextAreaElement)) return null;
    if (!(saveButton instanceof HTMLButtonElement)) return null;
    return { modal, textarea, saveButton };
  }

  function updateGiftMessageSaveButtonState() {
    const modalElements = getGiftMessageModalElements();
    if (!modalElements) return;
    const hasValue = modalElements.textarea.value.trim().length > 0;
    modalElements.saveButton.disabled = !hasValue;
  }

  function openGiftMessageModal(button) {
    const modalElements = getGiftMessageModalElements();
    if (!modalElements) return;

    giftWrapDrawerState.messageContext = {
      line: button.dataset.cartLine || '',
      key: button.dataset.cartKey || '',
      quantity: button.dataset.cartLineQuantity || '',
      wrapperId: button.dataset.wrapperId || '',
      properties: parseLineProperties(button.dataset.lineProperties),
    };

    modalElements.textarea.value = button.dataset.currentMessage || '';
    if (!modalElements.modal.open) {
      modalElements.modal.showModal();
    }
    updateGiftMessageSaveButtonState();
    window.setTimeout(() => {
      modalElements.textarea.focus();
      modalElements.textarea.setSelectionRange(modalElements.textarea.value.length, modalElements.textarea.value.length);
    }, 0);
  }

  function closeGiftMessageModal() {
    const modalElements = getGiftMessageModalElements();
    if (!modalElements) return;
    if (modalElements.modal.open) {
      modalElements.modal.close();
    }
    giftWrapDrawerState.messageContext = null;
  }

  async function saveGiftMessageFromModal(button) {
    const modalElements = getGiftMessageModalElements();
    const context = giftWrapDrawerState.messageContext;
    if (!modalElements || !context) return;
    if (!context.line || !context.quantity) return;
    const trimmed = modalElements.textarea.value.trim();
    await syncGiftWrapDisplayProperties({
      wrapperId: context.wrapperId,
      giftWrapLineKey: context.key,
      giftMessage: trimmed,
    });
    await syncAssignedProductsGiftMessage({
      wrapperId: context.wrapperId,
      giftMessage: trimmed,
    });
    closeGiftMessageModal();
  }

  async function updateCartLine({ line, key, quantity, properties, includeSections = true }) {
    const sectionIds = getSectionIds();
    const basePayload = {
      quantity: Number(quantity),
      properties: normalizeProperties(properties),
    };
    if (includeSections) {
      basePayload.sections = sectionIds.join(',');
      basePayload.sections_url = window.location.pathname;
    }

    const lineNumber = Number(line);
    const hasValidLine = Number.isFinite(lineNumber) && lineNumber > 0;
    const payloads = [];
    if (key) {
      payloads.push({ ...basePayload, id: key });
    }
    if (hasValidLine) {
      payloads.push({ ...basePayload, line: lineNumber });
    }
    if (!payloads.length) {
      throw new Error('Missing valid line reference for cart update');
    }

    let responseData = null;
    let lastError = 'Failed to update cart line';
    for (let index = 0; index < payloads.length; index += 1) {
      const payload = payloads[index];
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        responseData = await response.json();
        break;
      }

      try {
        const errorData = await response.json();
        lastError = errorData?.description || errorData?.message || lastError;
      } catch (error) {
        // Keep fallback message when response is not JSON.
      }

      const canRetryWithAlternateReference = index < payloads.length - 1;
      if (!canRetryWithAlternateReference) {
        throw new Error(lastError);
      }
    }

    if (!responseData) {
      throw new Error(lastError);
    }
    setLiveCartCache(responseData);
    if (includeSections) {
      triggerCartUpdate(responseData?.sections, Array.isArray(responseData?.items) ? responseData : null);
    }
    return responseData;
  }

  async function addGiftWrapInstances(variantId, count = 1) {
    const normalizedVariantId = Number(variantId);
    const normalizedCount = Number(count);
    if (!normalizedVariantId || normalizedCount <= 0) return;
    const sectionIds = getSectionIds();
    const items = [];
    for (let index = 0; index < normalizedCount; index += 1) {
      const uniqueInstanceId = generateWrapperInstanceId();
      items.push({
        id: normalizedVariantId,
        quantity: 1,
        properties: {
          _gift_wrap_source: 'cart_drawer',
          _gift_wrap_instance_id: uniqueInstanceId,
        },
      });
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add gift wrap');
    }

    const responseData = await response.json();
    clearLiveCartCache();
    // Avoid an immediate extra /cart.js request here. The cart sections from /cart/add.js
    // are enough to refresh drawer UI, and live cart data can be fetched lazily when needed.
    triggerCartUpdate(responseData?.sections);
  }

  async function addRegularProductSplitInstances(lineItem, count = 1) {
    const normalizedCount = Number(count);
    const variantId = Number(lineItem?.variant_id || 0);
    if (!variantId || normalizedCount <= 0) return;

    const baseProperties = sanitizeSplitLineProperties(lineItem?.properties || {});
    const sectionIds = getSectionIds();
    const items = [];
    for (let index = 0; index < normalizedCount; index += 1) {
      const item = {
        id: variantId,
        quantity: 1,
        properties: {
          ...baseProperties,
          _gift_wrap_split_instance_id: `gws_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        },
      };

      const sellingPlanId = Number(lineItem?.selling_plan_allocation?.selling_plan?.id || 0);
      if (sellingPlanId > 0) {
        item.selling_plan = sellingPlanId;
      }
      items.push(item);
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add split product line');
    }

    const responseData = await response.json();
    clearLiveCartCache();
    triggerCartUpdate(responseData?.sections);
  }

  async function handleAddGiftWrap(button) {
    const variantId = button.dataset.giftVariantId;
    if (!variantId) return;
    await addGiftWrapInstances(variantId, 1);
  }

  async function handleAssignProduct(button) {
    const line = button.dataset.cartLine;
    const key = button.dataset.cartKey;
    const quantity = button.dataset.cartLineQuantity;
    const wrapperId = button.dataset.wrapperId;
    const wrapperCartKey = button.dataset.wrapperCartKey || '';
    if (!line || !quantity || !wrapperId) return;

    const fallbackProperties = parseLineProperties(button.dataset.lineProperties);
    let liveCartData = await getLiveCartData();
    let liveLineItem = await getLiveLineItem({ key, line, cartData: liveCartData });
    if (!liveLineItem) {
      liveCartData = await getLiveCartData({ force: true });
      liveLineItem = await getLiveLineItem({ key, line, cartData: liveCartData });
    }
    if (!liveLineItem) {
      console.warn('Assign aborted: could not resolve live cart line reference', { key, line });
      return;
    }
    const liveProperties = liveLineItem.properties || (await getLiveLineProperties({ key, line, cartData: liveCartData }));
    const wrapperGiftLine = (liveCartData?.items || []).find((item) => {
      if (!item) return false;
      if (wrapperCartKey && item.key === wrapperCartKey) return true;
      if (Number(item.product_id || 0) !== Number(getConfiguredGiftWrapProductId() || 0)) return false;
      return getWrapperInstanceIdFromItem(item) === wrapperId;
    });
    const wrapperGiftMessage = String(
      wrapperGiftLine?.properties?._gift_wrap_message || wrapperGiftLine?.properties?.['Gift Message'] || ''
    ).trim();
    // Always prefer live line properties to avoid dropping hidden personalization fields.
    let properties = { ...(liveProperties || fallbackProperties) };
    properties._gift_wrap_instance_id = wrapperId;
    delete properties['Gift Wrap Instance'];
    if (wrapperGiftMessage) {
      properties['Gift Message'] = wrapperGiftMessage;
    } else {
      delete properties['Gift Message'];
    }
    const liveQuantity = Number(liveLineItem?.quantity || quantity || 0);
    const liveVariantId = Number(liveLineItem?.variant_id || 0);
    const sourceLineKey = liveLineItem?.key || key || '';
    let updateResult = null;

    // Support per-unit assignment: for multi-qty lines, split one unit into the selected wrapper.
    if (liveQuantity > 1 && liveVariantId > 0 && sourceLineKey) {
      const unassignedProperties = normalizeProperties(liveLineItem?.properties || liveProperties || fallbackProperties || {});

      // Keep remaining quantity on the original line without assignment metadata.
      await updateCartLine({
        line,
        key: sourceLineKey,
        quantity: liveQuantity - 1,
        properties: unassignedProperties,
        includeSections: false,
      });

      const assignedItem = {
        id: liveVariantId,
        quantity: 1,
        properties,
      };

      const sellingPlanId = Number(liveLineItem?.selling_plan_allocation?.selling_plan?.id || 0);
      if (sellingPlanId > 0) {
        assignedItem.selling_plan = sellingPlanId;
      }

      const sectionIds = getSectionIds();
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [assignedItem],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      if (!addResponse.ok) {
        throw new Error('Failed to split and assign cart line');
      }

      const addResponseData = await addResponse.json();
      clearLiveCartCache();
      const latestCartData = await getLiveCartData({ force: true });
      triggerCartUpdate(addResponseData?.sections, latestCartData);
      updateResult = latestCartData;
    } else {
      updateResult = await updateCartLine({
        key: sourceLineKey,
        quantity: liveQuantity,
        properties,
        includeSections: true,
      });
    }
    await syncGiftWrapDisplayProperties({
      wrapperId,
      giftWrapLineKey: wrapperCartKey,
      cartData: updateResult,
      includeSections: false,
    }).catch((error) => {
      console.error('Failed to sync gift wrap display properties after assign', error);
    });
    await syncAssignedProductsGiftMessage({
      wrapperId,
      giftMessage: wrapperGiftMessage,
      cartData: updateResult,
      includeSections: false,
    }).catch((error) => {
      console.error('Failed to sync assigned product gift messages after assign', error);
    });
  }

  async function handleUnassignProduct(button) {
    const line = button.dataset.cartLine;
    const key = button.dataset.cartKey;
    const quantity = button.dataset.cartLineQuantity;
    const previousWrapperId = button.dataset.wrapperId || '';
    const previousWrapperCartKey = button.dataset.wrapperCartKey || '';
    if (!line || !quantity) return;

    const fallbackProperties = parseLineProperties(button.dataset.lineProperties);
    let liveCartData = await getLiveCartData();
    let liveLineItem = await getLiveLineItem({ key, line, cartData: liveCartData });
    if (!liveLineItem) {
      liveCartData = await getLiveCartData({ force: true });
      liveLineItem = await getLiveLineItem({ key, line, cartData: liveCartData });
    }
    if (!liveLineItem) {
      console.warn('Unassign aborted: could not resolve live cart line reference', { key, line });
      return;
    }
    const liveProperties = liveLineItem.properties || (await getLiveLineProperties({ key, line, cartData: liveCartData }));
    // Always prefer live line properties to avoid dropping hidden personalization fields.
    let properties = sanitizeSplitLineProperties(liveProperties || fallbackProperties || {});
    // Ensure we don't send an empty properties object on unassign: Shopify can ignore that edge case.
    if (!Object.keys(properties).length) {
      properties = {
        _gift_wrap_split_instance_id: `gws_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      };
    }

    const updateResult = await updateCartLine({
      key: liveLineItem.key || key,
      quantity: Number(liveLineItem.quantity || quantity || 0),
      properties,
      includeSections: true,
    });
    if (previousWrapperId) {
      await syncGiftWrapDisplayProperties({
        wrapperId: previousWrapperId,
        giftWrapLineKey: previousWrapperCartKey,
        cartData: updateResult,
      }).catch(
        (error) => {
          console.error('Failed to sync gift wrap display properties after unassign', error);
        }
      );
    } else {
      triggerCartUpdate({});
    }
  }

  async function normalizeGiftWrapLines() {
    if (giftWrapDrawerState.isNormalizingGiftWrapLines) return false;

    const cards = Array.from(document.querySelectorAll(giftWrapCardSelector));
    if (!cards.length) return false;

    const linesByKey = new Map();
    for (const card of cards) {
      const key = card.getAttribute('data-gift-wrap-cart-key');
      if (!key || linesByKey.has(key)) continue;

      const wrapperId = card.getAttribute('data-wrapper-id') || '';
      const quantity = Number(card.getAttribute('data-gift-wrap-line-quantity') || '0');
      const variantId = Number(card.getAttribute('data-gift-wrap-variant-id') || '0');
      const properties = parseLineProperties(card.getAttribute('data-gift-wrap-line-properties') || '');
      linesByKey.set(key, { key, wrapperId, quantity, variantId, properties });
    }

    const linesToSplit = Array.from(linesByKey.values()).filter((lineData) => lineData.quantity > 1 && lineData.variantId > 0);
    if (!linesToSplit.length) return false;

    giftWrapDrawerState.isNormalizingGiftWrapLines = true;
    try {
      const liveCartData = await getLiveCartData();
      const liveItemsByKey = new Map((liveCartData?.items || []).map((item) => [item.key, item]));
      const sectionIds = getSectionIds();
      let latestSections = {};

      for (let lineIndex = 0; lineIndex < linesToSplit.length; lineIndex += 1) {
        const lineData = linesToSplit[lineIndex];
        const liveLine = liveItemsByKey.get(lineData.key) || null;
        const liveLineQuantity = Number(liveLine?.quantity || lineData.quantity || 0);
        const liveLineVariantId = Number(liveLine?.variant_id || lineData.variantId || 0);
        if (liveLineQuantity <= 1 || liveLineVariantId <= 0) continue;

        const liveLineProperties = normalizeProperties(liveLine?.properties || {});
        const fallbackProperties = normalizeProperties(lineData.properties);
        const currentProperties = Object.keys(liveLineProperties).length ? liveLineProperties : fallbackProperties;
        const primaryWrapperInstanceId =
          currentProperties._gift_wrap_instance_id ||
          currentProperties['Gift Wrap Instance'] ||
          lineData.wrapperId ||
          generateWrapperInstanceId();
        const primaryLineProperties = {
          ...currentProperties,
          _gift_wrap_source: currentProperties._gift_wrap_source || 'cart_drawer',
          _gift_wrap_instance_id: primaryWrapperInstanceId,
        };
        delete primaryLineProperties['Gift Wrap Instance'];

        // Keep one line item as quantity 1 and normalize its properties.
        const additionalWrappers = liveLineQuantity - 1;
        const isLastLine = lineIndex === linesToSplit.length - 1;
        const includeSectionsOnPrimary = isLastLine && additionalWrappers === 0;
        const primaryPayload = {
          id: lineData.key,
          quantity: 1,
          properties: primaryLineProperties,
        };
        if (includeSectionsOnPrimary) {
          primaryPayload.sections = sectionIds.join(',');
          primaryPayload.sections_url = window.location.pathname;
        }
        const primaryLineResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(primaryPayload),
        });
        if (!primaryLineResponse.ok) {
          throw new Error('Failed to normalize primary gift wrap line');
        }
        const primaryLineData = await primaryLineResponse.json();
        if (includeSectionsOnPrimary) {
          latestSections = primaryLineData?.sections || latestSections;
        }

        // Add only the additional wrappers needed.
        const baseProperties = { ...currentProperties };
        delete baseProperties._gift_wrap_instance_id;
        delete baseProperties['Gift Wrap Instance'];
        delete baseProperties._gift_wrap_message;
        delete baseProperties['Gift Message'];
        clearAttachedProductProperties(baseProperties);

        if (additionalWrappers > 0) {
          const includeSections = isLastLine;
          const addItems = [];
          for (let index = 0; index < additionalWrappers; index += 1) {
            const wrapperInstanceId = generateWrapperInstanceId();
            addItems.push({
              id: liveLineVariantId,
              quantity: 1,
              properties: {
                ...baseProperties,
                _gift_wrap_source: baseProperties._gift_wrap_source || 'cart_drawer',
                _gift_wrap_instance_id: wrapperInstanceId,
              },
            });
          }

          const addPayload = { items: addItems };
          if (includeSections) {
            addPayload.sections = sectionIds.join(',');
            addPayload.sections_url = window.location.pathname;
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(addPayload),
          });
          if (!response.ok) {
            throw new Error('Failed to split gift wrap line');
          }
          const responseData = await response.json();
          if (includeSections) {
            latestSections = responseData?.sections || latestSections;
          }
        }
      }

      const latestCartData = await getLiveCartData({ force: true });
      triggerCartUpdate(latestSections, latestCartData);
      clearLiveCartCache();
      return true;
    } catch (error) {
      console.error('Gift wrap normalization failed', error);
      return false;
    } finally {
      giftWrapDrawerState.isNormalizingGiftWrapLines = false;
    }
  }

  function scheduleNormalizeGiftWrapLines(delay = 40) {
    if (giftWrapDrawerState.normalizeTimer) {
      window.clearTimeout(giftWrapDrawerState.normalizeTimer);
    }
    giftWrapDrawerState.normalizeTimer = window.setTimeout(() => {
      giftWrapDrawerState.normalizeTimer = null;
      normalizeGiftWrapLines();
    }, delay);
  }

  function setGiftAssignmentActionsDisabled(disabled) {
    const actionButtons = document.querySelectorAll(`${assignButtonSelector}, ${unassignButtonSelector}`);
    actionButtons.forEach((element) => {
      if (!(element instanceof HTMLButtonElement)) return;
      element.disabled = disabled;
    });
  }

  const handleGiftWrapDrawerClick = async (event) => {
    const button = event.target.closest(
      `${giftWrapButtonSelector}, ${assignButtonSelector}, ${unassignButtonSelector}, ${editMessageButtonSelector}, ${saveMessageButtonSelector}, ${closeMessageButtonSelector}`
    );
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();

    if (button.matches(closeMessageButtonSelector)) {
      closeGiftMessageModal();
      return;
    }

    if (button.matches(editMessageButtonSelector)) {
      openGiftMessageModal(button);
      return;
    }

    if (button.disabled) return;
    if (giftWrapDrawerState.isNormalizingGiftWrapLines) return;
    const isAssignmentAction = button.matches(assignButtonSelector) || button.matches(unassignButtonSelector);
    if (isAssignmentAction && giftWrapDrawerState.isAssigningGiftItem) return;

    button.disabled = true;
    button.classList.add(loadingClass);
    if (isAssignmentAction) {
      giftWrapDrawerState.isAssigningGiftItem = true;
      setGiftAssignmentActionsDisabled(true);
    }

    try {
      // Assignment/unassignment should feel immediate and not wait for normalize preflight.
      if (button.matches(giftWrapButtonSelector)) {
        const normalized = await normalizeGiftWrapLines();
        if (normalized) return;
      }

      if (button.matches(giftWrapButtonSelector)) {
        await handleAddGiftWrap(button);
      } else if (button.matches(assignButtonSelector)) {
        await handleAssignProduct(button);
      } else if (button.matches(unassignButtonSelector)) {
        await handleUnassignProduct(button);
      } else if (button.matches(saveMessageButtonSelector)) {
        await saveGiftMessageFromModal(button);
      }
    } catch (error) {
      console.error('Gift wrap drawer action failed', error);
    } finally {
      button.disabled = false;
      button.classList.remove(loadingClass);
      if (isAssignmentAction) {
        giftWrapDrawerState.isAssigningGiftItem = false;
        setGiftAssignmentActionsDisabled(false);
      }
    }
  };

  if (window.__giftWrapDrawerClickHandler) {
    document.removeEventListener('click', window.__giftWrapDrawerClickHandler);
  }
  window.__giftWrapDrawerClickHandler = handleGiftWrapDrawerClick;
  document.addEventListener('click', window.__giftWrapDrawerClickHandler);

  const handleGiftWrapQuantityPlusClick = async (event) => {
    if (!getConfiguredGiftWrapProductId()) return;

    const plusButton = event.target.closest(quantityPlusSelector);
    if (!(plusButton instanceof HTMLButtonElement)) return;

    const row = plusButton.closest('.cart-items__table-row');
    if (!(row instanceof HTMLTableRowElement)) return;

    const rowProductId = row.dataset.productId;
    const rowVariantId = row.dataset.variantId;
    if (!rowProductId || !rowVariantId) return;
    const isGiftWrapRow = String(rowProductId) === String(getConfiguredGiftWrapProductId());
    const hasGiftWrapInCartFromDom = !!document.querySelector(
      `.cart-items__table-row[data-product-id="${getConfiguredGiftWrapProductId()}"]`
    );
    if (
      giftWrapDrawerState.isNormalizingGiftWrapLines ||
      giftWrapDrawerState.isFastAddingGiftWrap ||
      giftWrapDrawerState.isFastAddingRegularProduct
    ) {
      return;
    }
    if (!isGiftWrapRow && !hasGiftWrapInCartFromDom) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (isGiftWrapRow) {
      giftWrapDrawerState.isFastAddingGiftWrap = true;
    } else {
      giftWrapDrawerState.isFastAddingRegularProduct = true;
    }
    setDrawerInteractionLock(true);
    plusButton.disabled = true;
    plusButton.classList.add(loadingClass);
    try {
      if (isGiftWrapRow) {
        await handleAddGiftWrap({ dataset: { giftVariantId: rowVariantId } });
      } else {
        const liveCartData = await getLiveCartData();
        const quantityInput = row.querySelector('input[data-cart-line]');
        const cartLine = Number(quantityInput?.dataset?.cartLine || 0);
        const liveLineItem = await getLiveLineItem({ line: cartLine, cartData: liveCartData });
        if (!liveLineItem) return;
        await addRegularProductSplitInstances(liveLineItem, 1);
      }
    } catch (error) {
      console.error('Cart fast add on increment failed', error);
    } finally {
      giftWrapDrawerState.isFastAddingGiftWrap = false;
      giftWrapDrawerState.isFastAddingRegularProduct = false;
      setDrawerInteractionLock(false);
      plusButton.disabled = false;
      plusButton.classList.remove(loadingClass);
    }
  };
  if (window.__giftWrapDrawerQuantityPlusHandler) {
    document.removeEventListener('click', window.__giftWrapDrawerQuantityPlusHandler, true);
  }
  window.__giftWrapDrawerQuantityPlusHandler = handleGiftWrapQuantityPlusClick;
  document.addEventListener('click', window.__giftWrapDrawerQuantityPlusHandler, true);

  const handleGiftWrapQuantitySelectorUpdate = async (event) => {
    if (!getConfiguredGiftWrapProductId()) return;
    const cartLine = Number(event?.detail?.cartLine || 0);
    const requestedQuantity = Number(event?.detail?.quantity || 0);
    if (!cartLine || !requestedQuantity) return;

    const quantityInput = document.querySelector(`input[data-cart-line="${cartLine}"]`);
    if (!(quantityInput instanceof HTMLInputElement)) return;
    const row = quantityInput.closest('.cart-items__table-row');
    if (!(row instanceof HTMLTableRowElement)) return;

    const rowProductId = row.dataset.productId;
    const rowVariantId = row.dataset.variantId;
    if (!rowProductId || !rowVariantId) return;
    const isGiftWrapRow = String(rowProductId) === String(getConfiguredGiftWrapProductId());
    const hasGiftWrapInCartFromDom = !!document.querySelector(
      `.cart-items__table-row[data-product-id="${getConfiguredGiftWrapProductId()}"]`
    );
    if (!hasGiftWrapInCartFromDom) return;

    // Stop propagation immediately (before any await) so cart-items-component does not
    // also run updateQuantity and change the existing line.
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    // Use cart's quantity as the "before" value: the input has already been updated by the
    // quantity selector before dispatching the event, so reading from DOM would give delta = 0.
    const liveCartData = await getLiveCartData();
    const liveLineItem = await getLiveLineItem({ line: cartLine, cartData: liveCartData });
    const currentQuantity = Number(liveLineItem?.quantity ?? quantityInput.value ?? 0);
    const quantityDelta = requestedQuantity - currentQuantity;
    if (quantityDelta <= 0) {
      quantityInput.value = String(currentQuantity);
      return;
    }
    if (
      giftWrapDrawerState.isNormalizingGiftWrapLines ||
      giftWrapDrawerState.isFastAddingGiftWrap ||
      giftWrapDrawerState.isFastAddingRegularProduct
    ) {
      return;
    }

    if (isGiftWrapRow) {
      giftWrapDrawerState.isFastAddingGiftWrap = true;
    } else {
      giftWrapDrawerState.isFastAddingRegularProduct = true;
    }
    setDrawerInteractionLock(true);
    quantityInput.value = String(currentQuantity);
    try {
      if (isGiftWrapRow) {
        await addGiftWrapInstances(rowVariantId, quantityDelta);
      } else {
        if (!liveLineItem) return;
        await addRegularProductSplitInstances(liveLineItem, quantityDelta);
      }
    } catch (error) {
      console.error('Product quantity interception failed', error);
    } finally {
      giftWrapDrawerState.isFastAddingGiftWrap = false;
      giftWrapDrawerState.isFastAddingRegularProduct = false;
      setDrawerInteractionLock(false);
    }
  };
  if (window.__giftWrapDrawerQuantityUpdateHandler) {
    document.removeEventListener(cartQuantityUpdateEventName, window.__giftWrapDrawerQuantityUpdateHandler, true);
  }
  window.__giftWrapDrawerQuantityUpdateHandler = handleGiftWrapQuantitySelectorUpdate;
  document.addEventListener(cartQuantityUpdateEventName, window.__giftWrapDrawerQuantityUpdateHandler, true);

  const handleGiftWrapDrawerCartUpdate = (event) => {
    closeGiftMessageModal();
    const eventSource = event?.detail?.data?.source;
    if (eventSource === 'cart-drawer-gift-wrap') {
      return;
    }
    scheduleNormalizeGiftWrapLines(40);
    if (eventSource === 'cart-items-component') {
      const eventCartData = event?.detail?.resource;
      window.setTimeout(() => {
        (async () => {
          const cleanedCartData = await removeOrphanedAssignedGiftMessages(eventCartData);
          await syncAllGiftWrapDisplayPropertiesFromCart(cleanedCartData);
        })().catch((error) => {
          console.error('Failed to sync gift wrap summaries from cart', error);
        });
      }, 120);
      return;
    }
    window.setTimeout(() => {
      syncGiftWrapDisplayPropertiesFromDom().catch((error) => {
        console.error('Failed to sync gift wrap summaries from DOM', error);
      });
    }, 120);
  };
  if (window.__giftWrapDrawerCartUpdateHandler) {
    document.removeEventListener('cart:update', window.__giftWrapDrawerCartUpdateHandler);
  }
  window.__giftWrapDrawerCartUpdateHandler = handleGiftWrapDrawerCartUpdate;
  document.addEventListener('cart:update', window.__giftWrapDrawerCartUpdateHandler);

  const handleGiftWrapDrawerInput = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLTextAreaElement)) return;
    if (!target.matches(messageTextareaSelector)) return;
    updateGiftMessageSaveButtonState();
  };
  if (window.__giftWrapDrawerInputHandler) {
    document.removeEventListener('input', window.__giftWrapDrawerInputHandler);
  }
  window.__giftWrapDrawerInputHandler = handleGiftWrapDrawerInput;
  document.addEventListener('input', window.__giftWrapDrawerInputHandler);

  scheduleNormalizeGiftWrapLines(0);
  } catch(e) { console.error(e); }
})();

})();
